<template>
  <section class="order-detail" v-loading="loading">
    <div @click="goback" class="go-back">返回></div>
    <order-header v-if="showChild" v-bind:detail="detailData"></order-header>
    <section class="order-detail-body">
      <section class="left">
        <section class="order-information">
          <order-entrace-info v-if="showChild" v-bind:entraceInfo="detailData"></order-entrace-info>
          <order-exit-info v-if="showChild" v-bind:exitInfo="detailData"></order-exit-info>
        </section>
        <order-geomagnetic-info v-if="showChild" v-bind:geomagneticInfo="alarmLogList"></order-geomagnetic-info>
        <order-error-info v-if="showChild" v-bind:feedback="feedback"></order-error-info>
      </section>
      <section class="right">
        <order-billing-info v-if="showChild" v-bind:billingInfo="detailData"></order-billing-info>
      </section>
    </section>
  </section>
</template>
<script>
import {
  OrderBillingInfo,
  OrderEntraceInfo,
  OrderErrorInfo,
  OrderExitInfo,
  OrderGeomagneticInfo,
  OrderHeader,
} from "./components";

import { queryOrderByPageExt,queryFeedbackByOrderNum,queryAlarmLogByOrderNum } from "@/api/url";
export default {
  name: "order-detail",
  data() {
    return {
      loading: false,
      showChild: false,
      detailData: {},
      feedback:[],
      alarmLogList:[],
      orderNum: "",
    };
  },
  components: {
    OrderHeader,
    OrderEntraceInfo,
    OrderExitInfo,
    OrderGeomagneticInfo,
    OrderBillingInfo,
    OrderErrorInfo,
  },
  activated: async function() {
    const orderNum = this.$route.query.orderNum;
    if (!orderNum || orderNum === this.orderNum) {this.showChild=true;return};
    this.orderNum = orderNum;
    await Promise.allSettled([this.getOrderInfo(orderNum), this.getFeedback(orderNum),this.getAlarmLogByOrderNum(orderNum)])
    .finally(
      ()=>{
     
        this.showChild = true;
        this.loading = false;
      }
      );
  
  },
  deactivated() {
    this.showChild = false;
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    getOrderInfo(orderNum) {
      this.loading = true;
      return this.$get(queryOrderByPageExt(), { orderNum })
        .then((res) => {
          this.detailData =( res?.data?.rows?.[0]) ?? {};
          this.detailData.platenumImage=this.detailData?.platenumImage?.split(",");
        })
    },
    getFeedback(orderNum) {
      return this.$get(queryFeedbackByOrderNum(), { orderNum })
        .then((res) => {
          this.feedback = (res?.data ?? []).map(item => {
            const fbImg=[];
            if(item.imageHead)fbImg.push(item.imageHead);
            if(item.imageTail)fbImg.push(item.imageTail);
            if(item.imageSideways)fbImg.push(item.imageSideways);
            return {
              ...item,
              fbImg
            };
          });
        })
    },
    getAlarmLogByOrderNum(orderNum){
      return this.$get(queryAlarmLogByOrderNum(), { orderNum })
        .then(res => {
          console.log("alarm log=>", res.data)
          this.alarmLogList = res?.data?.map(item => {
            return {
              ...item,
              
            };
          })??[];
        })
    }
  },
};
</script>
<style scoped>
.order-detail {
  background: white;
  padding: 20px 20px;
  height: calc(100vh - 75px);
  overflow-y: auto;
 

}
.order-detail-body {
  display: flex;
  justify-content: space-between;
}
.order-detail-body .left {
  width: 70%;
  padding-right:5%;
  box-sizing: border-box;
}
.order-detail-body .right {
  width: 30%;
}
.order-information {
  display: flex;
  justify-content: space-between;
}
.go-back {
  cursor: pointer;
}
</style>
